import Input from 'b2b-ui-components-lib/lib/components/input';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import { IFORM } from 'featureLib/FormBuilder';
import Select from 'b2b-ui-components-lib/lib/components/select';
import {
  OlmIdValidator,
  addressValidator,
  alphaNumericValidatorWithSpecialCharacters,
  emailValidaotr,
  gstinValidator,
  mobileValidator,
  pincodeValidator,
  salesCodeValidator
} from 'common/utils/validator';
import { PAN_GST_RADIO_OPTIONS, RADIO_OPTIONS } from 'home/view/manage-feasibility/constants';
import { TYPEOF_ORDER } from 'common/constants/app.constants';
import AccountSelector from './AccountSelector';
import CheckboxWrapper from './CheckboxWrapper';

// const LoaderComponent = () => {
//   return (<span className="loading_icon"></span>)
// };

export const typeOfOrderOptions = [
  { displayName: 'New Order', key: TYPEOF_ORDER.NEW, products: ['DEDICATED_INTERNET', 'VPN', 'NLD', 'LL'] },
  { displayName: 'Upgrade Order', key: TYPEOF_ORDER.UPGRADE, products: ['DEDICATED_INTERNET', 'VPN'] },
  { displayName: 'Shifting Order', key: TYPEOF_ORDER.SHIFTING, products: ['DEDICATED_INTERNET', 'VPN'] },
  { displayName: 'New Pre Order', key: TYPEOF_ORDER.NEW_PRE_ORDER, products: ['DEDICATED_INTERNET', 'VPN', 'NLD', 'LL'] },
  { displayName: 'Upgrade Pre Order', key: TYPEOF_ORDER.UPGRADE_PRE_ORDER, products: ['DEDICATED_INTERNET', 'VPN'] }
];

export const typeOfOrderOptionsAOI = [{ displayName: 'New Order', key: TYPEOF_ORDER.NEW, products: ['DSL'] }];

export const productOptions = [
  { displayName: 'VPN (MPLS)', key: 'VPN' },
  { displayName: 'Dedicated Internet (ILL)', key: 'DEDICATED_INTERNET' },
  { displayName: 'Direct VPN (NLD)', key: 'NLD' },
  { displayName: 'Local Loop (LL)', key: 'LL' }
];

export const productOptionsAOI = [{ displayName: 'DSL', key: 'DSL' }];

export const DEFAULT_FORM_CONFIG: IFORM = {
  selectedAccount: {
    key: 'selectedAccount',
    isMandatory: true,
    value: '',
    label: 'Account Selected',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    disabled: false,
    element: {
      type: AccountSelector
    }
  },
  productType: {
    key: 'productType',
    isMandatory: true,
    value: '',
    label: 'Product Type',
    className: 'flg-lg-6 flg-md-6 flg-sm-12 row_section',
    element: {
      type: Select,
      props: {
        options: productOptions
      }
    }
  },
  typeOfOrder: {
    key: 'typeOfOrder',
    isMandatory: true,
    value: '',
    label: 'Type of Order',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    element: {
      type: Select,
      props: {
        options: typeOfOrderOptions
      }
    }
  },
  orderNickName: {
    key: 'orderNickName',
    isMandatory: true,
    value: '',
    label: 'Order Nickname',
    validator: alphaNumericValidatorWithSpecialCharacters,
    className: 'flg-lg-6 flg-md-6 flg-sm-12 row_section',
    element: {
      type: Input
    }
  },
  loiAvailable: {
    key: 'loiAvailable',
    isMandatory: false,
    hide: true,
    label: 'I acknowledge that I have the letter of intent readily available.',
    className: 'flg-lg-12 flg-md-12 flg-sm-12 loi_checkbox',
    value: true,
    element: {
      type: CheckboxWrapper,
      props: {}
    }
  },
  siteType: {
    key: 'siteType',
    isMandatory: true,
    label: 'Site Type',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    value: RADIO_OPTIONS[1],
    element: {
      type: RadioGroup,
      props: {
        options: RADIO_OPTIONS
      }
    }
  }
};

export const DEFAULT_FORM_CONFIG_AOI: IFORM = {
  salesCode: {
    key: 'salesCode',
    isMandatory: true,
    value: '',
    label: 'Sales code',
    validator: salesCodeValidator,
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    element: {
      type: Input
    }
  },
  olmId: {
    key: 'olmId',
    isMandatory: true,
    value: '',
    label: 'OLM ID',
    validator: OlmIdValidator,
    className: 'flg-lg-6 flg-md-6 flg-sm-12 row_section',
    element: {
      type: Input
    }
  },
  initiatorFullName: {
    key: 'fullName',
    isMandatory: true,
    value: '',
    label: 'Full Name',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    validator: alphaNumericValidatorWithSpecialCharacters,
    element: { type: Input }
  },
  initiatorPhoneNumber: {
    key: 'phoneNumber',
    isMandatory: true,
    value: '',
    label: 'Phone Number',
    className: 'flg-lg-6 flg-md-6 flg-sm-12 row_section',
    validator: mobileValidator,
    element: { type: Input, props: { maxlength: 10 } }
  },
  accountName: {
    key: 'accountName',
    isMandatory: true,
    value: '',
    label: 'Account Name',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    hide: true,
    disabled: false,
    element: {
      type: Select,
      props: {
        options: []
      }
    }
  },
  address: {
    key: 'address',
    isMandatory: true,
    value: '',
    label: 'Address',
    disabled: true,
    hide: true,
    // validator: alphaNumericValidatorWithSpecialCharacters,
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    element: {
      type: Input
    }
  },
  productType: {
    key: 'productType',
    isMandatory: true,
    value: '',
    label: 'Product Type',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    hide: true,
    element: {
      type: Select,
      props: {
        options: productOptionsAOI
      }
    }
  },
  typeOfOrder: {
    key: 'typeOfOrder',
    isMandatory: true,
    value: '',
    label: 'Type of Order',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    hide: true,
    element: {
      type: Select,
      props: {
        options: typeOfOrderOptions
      }
    }
  },
  siteType: {
    key: 'siteType',
    isMandatory: true,
    label: 'Site Type',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    value: RADIO_OPTIONS[1],
    element: {
      type: RadioGroup,
      props: {
        options: RADIO_OPTIONS
      }
    }
  }
};

export const CONTACT_DETAILS_FORM_CONFIG: IFORM = {
  fullName: {
    key: 'fullName',
    isMandatory: true,
    value: '',
    label: 'Full Name',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    validator: alphaNumericValidatorWithSpecialCharacters,
    element: { type: Input }
  },
  phoneNumber: {
    key: 'phoneNumber',
    isMandatory: true,
    value: '',
    label: 'Phone Number',
    className: 'flg-lg-6 flg-md-6 flg-sm-12 row_section',
    validator: mobileValidator,
    element: { type: Input, props: { maxlength: 10 } }
  },
  emailAddress: {
    key: 'emailAddress',
    isMandatory: true,
    value: '',
    label: 'Email Address',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    validator: emailValidaotr,
    element: { type: Input }
  }
};

export const ACCOUNT_ADDRESS_CONFIG_AOI: IFORM = {
  accountName: {
    key: 'accountName',
    isMandatory: true,
    value: '',
    label: 'Account Name',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    disabled: false,
    hide: true,
    element: {
      type: Select,
      props: {
        options: []
      }
    }
  },
  address: {
    key: 'address',
    isMandatory: true,
    value: '',
    label: 'Address',
    disabled: true,
    hide: true,
    // validator: alphaNumericValidatorWithSpecialCharacters,
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    element: {
      type: Input
    }
  }
};

export const PAN_GST_FORM_CONFIG_AOI: IFORM = {
  searchType: {
    key: 'searchType',
    isMandatory: true,
    label: 'Search Type',
    className: 'flg-lg-12 flg-md-12 flg-sm-12',
    value: PAN_GST_RADIO_OPTIONS[0],
    element: {
      type: RadioGroup,
      props: {
        options: PAN_GST_RADIO_OPTIONS
      }
    }
  },
  // loader: {
  //   key: 'loader',
  //   isMandatory: true,
  //   label: 'Search Type',
  //   className: 'flg-lg-12 flg-md-12 flg-sm-12',
  //   value: PAN_GST_RADIO_OPTIONS[0],
  //   element: {
  //     type: () => <span className="loading_icon"></span>,
  //     props: {
  //       options: PAN_GST_RADIO_OPTIONS
  //     }
  //   }
  // },
  searchValue: {
    key: 'searchValue',
    isMandatory: true,
    value: '',
    label: 'Please enter value',
    validator: gstinValidator,
    className: 'flg-lg-6 flg-md-6 flg-sm-12 position_relative',
    element: {
      type: Input
    }
  },
  /** To bring accountName and address in the next line of the form **/
  // dummyWidth: {
  //   key: 'dummyWidth',
  //   isMandatory: false,
  //   value: '',
  //   label: 'Please enter value',
  //   className: 'flg-lg-8 flg-md-8 flg-sm-12 visibility_hidden',
  //   element: {
  //     type: Input
  //   }
  // },

  accountName: {
    key: 'accountName',
    isMandatory: true,
    value: '',
    label: 'Account Name',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    disabled: false,
    hide: true,
    element: {
      type: Select,
      props: {
        options: []
      }
    }
  },

  addressLine: {
    key: 'addressLine',
    isMandatory: true,
    value: '',
    label: 'Address ',
    className: 'flg-lg-12 flg-md-12 flg-sm-12',
    disabled: false,
    validator: addressValidator,
    hide: true,
    element: {
      type: Input,
      props: {
        options: []
      }
    }
  },
  pincode: {
    key: 'pincode',
    isMandatory: true,
    value: '',
    label: 'Pincode',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    disabled: false,
    hide: true,
    validator: pincodeValidator,
    element: {
      type: Input
    }
  },
  city: {
    key: 'city',
    isMandatory: true,
    value: '',
    label: 'City',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    disabled: true,
    hide: true,
    element: {
      type: Select,
      props: {
        options: []
      }
    }
  },

  address: {
    key: 'address',
    isMandatory: true,
    value: '',
    label: '',
    disabled: true,
    hide: true,
    // validator: alphaNumericValidatorWithSpecialCharacters,
    className: 'flg-lg-6 flg-md-6 flg-sm-12 remove_border',
    element: {
      type: Input
    }
  }
};
